<template>
<div class="chapter">
<div class="inner_page">
<p class="toc2"><span><b>CONTENTS</b></span></p>
<p class="toc2"><a href="#/Book1/1cover#cover">MERIDIAN</a></p>
<p class="toc2"><a href="#/Book1/7chap1#chap1">Meridian</a></p>
<p class="toc1"><a href="#/Book1/8chap2#chap2">The Last Return</a></p>
<p class="toc1"><a href="#/Book1/9chap3#chap3">The Wild Child</a></p>
<p class="toc1"><a href="#/Book1/10chap4#chap4">Sojourner</a></p>
<p class="toc1"><a href="#/Book1/11chap5#chap5">“Have You Stolen Anything?”</a></p>
<p class="toc1"><a href="#/Book1/12chap6#chap6">Gold</a></p>
<p class="toc1"><a href="#/Book1/13chap7#chap7">Indians and Ecstasy</a></p>
<p class="toc1"><a href="#/Book1/14chap8#chap8">English Walnuts</a></p>
<p class="toc1"><a href="#/Book1/15chap9#chap9">The Happy Mother</a></p>
<p class="toc1"><a href="#/Book1/16chap10#chap10">Clouds</a></p>
<p class="toc1"><a href="#/Book1/17chap11#chap11">The Attainment of Good</a></p>
<p class="toc1"><a href="#/Book1/18chap12#chap12">Awakening</a></p>
<p class="toc1"><a href="#/Book1/19chap13#chap13">Battle Fatigue</a></p>
<p class="toc1"><a href="#/Book1/20chap14#chap14">The Driven Snow</a></p>
<p class="toc1"><a href="#/Book1/21chap15#chap15">The Conquering Prince</a></p>
<p class="toc1"><a href="#/Book1/22chap16#chap16">The Recurring Dream</a></p>
<p class="toc2"><a href="#/Book1/23chap17#chap17">Truman Held</a></p>
<p class="toc1"><a href="#/Book1/24chap18#chap18">Truman and Lynne: Time in the South</a></p>
<p class="toc1"><a href="#/Book1/25chap19#chap19">Of Bitches and Wives</a></p>
<p class="toc1"><a href="#/Book1/26chap20#chap20">The New York Times</a></p>
<p class="toc1"><a href="#/Book1/27chap21#chap21">Visits</a></p>
<p class="toc1"><a href="#/Book1/28chap22#chap22">Lynne</a></p>
<p class="toc1"><a href="#/Book1/29chap23#chap23">Tommy Odds</a></p>
<p class="toc1"><a href="#/Book1/30chap24#chap24">Lynne</a></p>
<p class="toc1"><a href="#/Book1/31chap25#chap25">On Giving Him Back to His Own</a></p>
<p class="toc1"><a href="#/Book1/32chap26#chap26">Two Women</a></p>
<p class="toc1"><a href="#/Book1/33chap27#chap27">Lynne</a></p>
<p class="toc2"><a href="#/Book1/34chap28#chap28">Ending</a></p>
<p class="toc1"><a href="#/Book1/35chap29#chap29">Free at Last</a></p>
<p class="toc1"><a href="#/Book1/36chap30#chap30">Questions</a></p>
<p class="toc1"><a href="#/Book1/37chap31#chap31">Camara</a></p>
<p class="toc1"><a href="#/Book1/38chap32#chap32">Travels</a></p>
<p class="toc1"><a href="#/Book1/39chap33#chap33">Treasure</a></p>
<p class="toc1"><a href="#/Book1/40chap34#chap34">Pilgrimage</a></p>
<p class="toc1"><a href="#/Book1/41chap35#chap35">Atonement: Later, in the Same Life</a></p>
<p class="toc1"><a href="#/Book1/42chap36#chap36">Settling Accounts</a></p>
<p class="toc1"><a href="#/Book1/43chap37#chap37">Release</a></p>
<p class="toc2"><a href="#/Book2/1cover#cover">THE THIRD LIFE OF GRANGE COPELAND</a></p>
<p class="toc2"><a href="#/Book2/6chap1#chap1">Part I</a></p>
<p class="toc1"><a href="#/Book2/7chap2#chap2">1</a></p>
<p class="toc1"><a href="#/Book2/8chap3#chap3">2</a></p>
<p class="toc1"><a href="#/Book2/9chap4#chap4">3</a></p>
<p class="toc2"><a href="#/Book2/10chap5#chap5">Part II</a></p>
<p class="toc1"><a href="#/Book2/11chap6#chap6">4</a></p>
<p class="toc1"><a href="#/Book2/12chap7#chap7">5</a></p>
<p class="toc1"><a href="#/Book2/13chap8#chap8">6</a></p>
<p class="toc1"><a href="#/Book2/14chap9#chap9">7</a></p>
<p class="toc1"><a href="#/Book2/15chap10#chap10">8</a></p>
<p class="toc1"><a href="#/Book2/16chap11#chap11">9</a></p>
<p class="toc1"><a href="#/Book2/17chap12#chap12">10</a></p>
<p class="toc1"><a href="#/Book2/18chap13#chap13">11</a></p>
<p class="toc1"><a href="#/Book2/19chap14#chap14">12</a></p>
<p class="toc1"><a href="#/Book2/20chap15#chap15">13</a></p>
<p class="toc2"><a href="#/Book2/21chap16#chap16">Part III</a></p>
<p class="toc1"><a href="#/Book2/22chap17#chap17">14</a></p>
<p class="toc1"><a href="#/Book2/23chap18#chap18">15</a></p>
<p class="toc1"><a href="#/Book2/24chap19#chap19">16</a></p>
<p class="toc2"><a href="#/Book2/25chap20#chap20">Part IV</a></p>
<p class="toc1"><a href="#/Book2/26chap21#chap21">17</a></p>
<p class="toc1"><a href="#/Book2/27chap22#chap22">18</a></p>
<p class="toc2"><a href="#/Book2/28chap23#chap23">Part V</a></p>
<p class="toc1"><a href="#/Book2/29chap24#chap24">19</a></p>
<p class="toc1"><a href="#/Book2/30chap25#chap25">20</a></p>
<p class="toc1"><a href="#/Book2/31chap26#chap26">21</a></p>
<p class="toc1"><a href="#/Book2/32chap27#chap27">22</a></p>
<p class="toc1"><a href="#/Book2/33chap28#chap28">23</a></p>
<p class="toc1"><a href="#/Book2/34chap29#chap29">24</a></p>
<p class="toc1"><a href="#/Book2/35chap30#chap30">25</a></p>
<p class="toc2"><a href="#/Book2/36chap31#chap31">Part VI</a></p>
<p class="toc1"><a href="#/Book2/37chap32#chap32">26</a></p>
<p class="toc1"><a href="#/Book2/38chap33#chap33">27</a></p>
<p class="toc1"><a href="#/Book2/39chap34#chap34">28</a></p>
<p class="toc1"><a href="#/Book2/40chap35#chap35">29</a></p>
<p class="toc1"><a href="#/Book2/41chap36#chap36">30</a></p>
<p class="toc1"><a href="#/Book2/42chap37#chap37">Part VII</a></p>
<p class="toc1"><a href="#/Book2/43chap38#chap38">31</a></p>
<p class="toc1"><a href="#/Book2/44chap39#chap39">32</a></p>
<p class="toc1"><a href="#/Book2/45chap40#chap40">33</a></p>
<p class="toc1"><a href="#/Book2/46chap41#chap41">34</a></p>
<p class="toc1"><a href="#/Book2/47chap42#chap42">35</a></p>
<p class="toc1"><a href="#/Book2/48chap43#chap43">36</a></p>
<p class="toc1"><a href="#/Book2/49chap44#chap44">37</a></p>
<p class="toc2"><a href="#/Book2/50chap45#chap45">Part VIII</a></p>
<p class="toc1"><a href="#/Book2/51chap46#chap46">38</a></p>
<p class="toc1"><a href="#/Book2/52chap47#chap47">39</a></p>
<p class="toc1"><a href="#/Book2/53chap48#chap48">40</a></p>
<p class="toc2"><a href="#/Book2/54chap49#chap49">Part IX</a></p>
<p class="toc1"><a href="#/Book2/55chap50#chap50">41</a></p>
<p class="toc1"><a href="#/Book2/56chap51#chap51">42</a></p>
<p class="toc1"><a href="#/Book2/57chap52#chap52">43</a></p>
<p class="toc1"><a href="#/Book2/58chap53#chap53">44</a></p>
<p class="toc2"><a href="#/Book2/59chap54#chap54">Part X</a></p>
<p class="toc1"><a href="#/Book2/60chap55#chap55">45</a></p>
<p class="toc1"><a href="#/Book2/61chap56#chap56">46</a></p>
<p class="toc2"><a href="#/Book2/62chap57#chap57">Part XI</a></p>
<p class="toc1"><a href="#/Book2/63chap58#chap58">47</a></p>
<p class="toc1"><a href="#/Book2/64chap59#chap59">48</a></p>
<p class="toc2"><a href="#/Comon/36biography#biography">A Biography of Alice Walker</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// bundle_content.vue?0b439796